import React from "react";
import { Grid, Typography } from "@mui/material";
import DesignCard from "./DesignCard";

export default function DesignCardGrid({
    designs,
    onEdit,
    onDelete,
    onPreview,
    onPublish,
    onRename,
}) {
    if (!designs.length) {
        return (
            <Typography color="text.secondary">
                Aucun design trouvé. Créez votre premier design.
            </Typography>
        );
    }

    return (
        <Grid container spacing={2}>
            {designs.map((design) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={design._id}>
                    <DesignCard
                        design={design}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onPreview={onPreview}
                        onPublish={onPublish}
                        onRename={onRename}
                    />
                </Grid>
            ))}
        </Grid>
    );
}
